function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#39C696",
  cx: "9",
  cy: "9",
  r: "9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.315 3.918c.085-.506.764-.559.95-.124l.03.093 1.119 4.839H14a.5.5 0 01.492.411l.008.09a.5.5 0 01-.41.492l-.09.008h-2.983a.5.5 0 01-.46-.306l-.027-.081-.642-2.774-1.249 7.516c-.084.507-.765.559-.95.123l-.03-.094-.999-4.385H4a.5.5 0 01-.492-.41l-.008-.09a.5.5 0 01.41-.491L4 8.727h3.059a.5.5 0 01.46.307l.027.082.523 2.295 1.246-7.493z",
  fill: "#FFF"
}))));